import { getQuery, insertQuery, updateQuery } from "./Auth0Wrapper";
import { addErrorLog } from "../Logger/logger";

export const resendVerificationEmail = async (user_id) => {
  try {
    const data = JSON.stringify({
      query: `mutation ResendVerificationEmail($data: JSON) {
  resendVerificationEmail(data: $data) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        data: {
          auth0_id: user_id
        }
      }
    });

    const response = await updateQuery(data);
    return response?.resendVerificationEmail;
  } catch (error) {
    addErrorLog("mutation ResendVerificationEmail", error, user_id);
    return null;
  }
};

export const generateOtp = async (auth0_id, email, tenant_id) => {
  const data = JSON.stringify({
    query: `mutation CreateOtp($auth0Id: String!, $email: String!, $tenantId: String!) {
              createOtp(auth0_id: $auth0Id, email: $email, tenant_id: $tenantId) {
                isSuccessful
                message
                resultObject
              }
            }`,
    variables: {
      auth0Id: auth0_id,
      email: email,
      tenantId: tenant_id
    }
  });
  try {
    const result = await insertQuery(data);
    return result?.createOtp;
  } catch (error) {
    addErrorLog("mutation CreateOtp", error, tenant_id);
    return null;
  }
};

export const verifyOtp = async (auth0_id, email, tenant_id, otp) => {
  const data = JSON.stringify({
    query: `query Query($auth0Id: String!, $email: String!, $tenantId: String!, $otp: String!) {
              verifyOTP(auth0_id: $auth0Id, email: $email, tenant_id: $tenantId, otp: $otp) {
                isSuccessful
                message
                resultObject
              }
            }`,
    variables: {
      auth0Id: auth0_id,
      email: email,
      tenantId: tenant_id,
      otp: otp
    }
  });
  try {
    const result = await getQuery(data);
    return result?.verifyOTP;
  } catch (error) {
    addErrorLog("query VerifyOtp", error, tenant_id);
    return null;
  }
};

export const userLogout = async (auth0_id, tenant_id) => {
  const data = JSON.stringify({
    query: `query UserLogout($tenantId: String!, $auth0Id: String!) {
              userLogout(tenant_id: $tenantId, auth0_id: $auth0Id) {
                isSuccessful
                message
                resultObject
              }
            }`,
    variables: {
      auth0Id: auth0_id,
      tenantId: tenant_id
    }
  });
  try {
    const result = await getQuery(data);
    return result?.userLogout;
  } catch (error) {
    addErrorLog("query UserLogout", error, tenant_id);
    return null;
  }
};

export const getUserByEmail = async (email) => {
  const data = JSON.stringify({
    query: `query GetUserByEmail($email: String!) {
              getUserByEmail(email: $email) {
                isSuccessful
                message
                resultObject
              }
            }`,
    variables: {
      email
    }
  });
  try {
    const result = await getQuery(data);
    return result?.getUserByEmail;
  } catch (error) {
    addErrorLog("query GetUserByEmail", error);
    return null;
  }
};

export const getSharedFlowCredential = async (tenant_id, credential_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetSharedFlowCredential($tenantId: String!, $credentialId: String!) {
  getSharedFlowCredential(tenant_id: $tenantId, credential_id: $credentialId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
        credentialId: credential_id
      }
    });
    const result = await getQuery(data);
    return result?.getSharedFlowCredential;
  } catch (error) {
    addErrorLog("query GetSharedFlowCredential", error, tenant_id);
    return null;
  }
};

export const getAuth0Token = async () => {
  try {
    const data = JSON.stringify({
      query: `
        query {
          getAuth0Token {
            isSuccessful
            message
            resultObject
          }
        }
      `
    });

    const result = await getQuery(data);
    return result?.getAuth0Token ?? null;
  } catch (error) {
    addErrorLog("query getAuth0Token", error);
    return null;
  }
};
